import React from "react";
import { Avatar, Button, Tag, Tooltip } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import { Localize } from "components/service";
import { timeFormat } from "utils/helper-functions";
import { getInitials, getScanPoints } from "./event-attendance-helper";

const getShiftScanDetails = (shift) => ({
    worker: shift.worker,
    subcontractor: shift.subcontractor,
    check_in_at: shift.check_in_at,
    check_out_at: shift.check_out_at,
    scan_logs: shift.scan_logs || [],
    points: getScanPoints(shift.scan_logs),
    isShiftDetails: true,
});

const EventAttendanceShiftsTableHelper = (openLocation) => {
    const columns = [
        {
            title: <Localize>TABLES.Column_Title_Worker</Localize>,
            dataIndex: "worker",
            width: "18%",
        },
        {
            title: <Localize>TABLES.Column_Title_Subcontractor</Localize>,
            dataIndex: "subcontractor",
            width: "17%",
        },
        {
            title: (
                <Tooltip title={ <Localize>TABLES.Tooltip_ShiftStatus</Localize> }>
                    <span><Localize>TABLES.Column_Title_ShiftStatus</Localize></span>
                </Tooltip>
            ),
            dataIndex: "status",
            width: "12%",
        },
        {
            title: <Localize>TABLES.Column_Title_CheckInTime</Localize>,
            dataIndex: "checkInTime",
            width: "17%",
        },
        {
            title: <Localize>TABLES.Column_Title_CheckOutTime</Localize>,
            dataIndex: "checkOutTime",
            width: "17%",
        },
        {
            title: (
                <Tooltip title={ <Localize>TABLES.Tooltip_ShiftScanLocations</Localize> }>
                    <span><Localize>TABLES.Column_Title_AttendanceScanLogs</Localize></span>
                </Tooltip>
            ),
            dataIndex: "scanLogs",
            align: "center",
            width: "19%",
        },
    ];

    const data = (shifts) => {
        if (!shifts)
        {
            return [];
        }

        return shifts.map((shift) => {
            const workerName = `${ shift.worker.name } ${ shift.worker.surname }`;
            const isCompleted = !!shift.check_out_at;
            const hasLogs = (shift.scan_logs || []).length > 0;

            return {
                key: shift.id,
                worker: (
                    <span className="event-check-logs-worker">
                        <Avatar size={ 32 }>{ getInitials(shift.worker) }</Avatar>
                        <span>{ workerName }</span>
                    </span>
                ),
                subcontractor: shift.subcontractor.title,
                status: (
                    <Tooltip title={
                        isCompleted ?
                            <Localize>CHECK_LOGS.Tooltip_StatusCompleted</Localize> :
                            <Localize>CHECK_LOGS.Tooltip_StatusActive</Localize>
                    }>
                        <Tag color={ isCompleted ? "blue" : "green" }>
                            <Localize>
                                { isCompleted ? "CHECK_LOGS.Status_Completed" : "CHECK_LOGS.Status_Active" }
                            </Localize>
                        </Tag>
                    </Tooltip>
                ),
                checkInTime: timeFormat(shift.check_in_at, "DD.MM.YYYY HH:mm:ss"),
                checkOutTime: isCompleted ? timeFormat(shift.check_out_at, "DD.MM.YYYY HH:mm:ss") : "-",
                scanLogs: (
                    <Tooltip title={
                        hasLogs ?
                            <Localize>TABLES.Tooltip_ShiftScanLocations</Localize> :
                            <Localize>CHECK_LOGS.Tooltip_NoScanLogs</Localize>
                    }>
                        <span>
                            <Button
                                type="text"
                                className="event-attendance-location-button event-attendance-location-button--logs"
                                disabled={ !hasLogs }
                                icon={ <EnvironmentOutlined /> }
                                onClick={ () => openLocation(getShiftScanDetails(shift)) }>
                                <Localize>CHECK_LOGS.Button_ScanLogs</Localize>
                            </Button>
                        </span>
                    </Tooltip>
                ),
            };
        });
    };

    return {
        columns,
        data,
    };
};

export default EventAttendanceShiftsTableHelper;
